<template>
  <div class="unit-import">
    <div class="container view">
      <div class="unit-import__wrapper">
        <Card
          tag="form"
          @submit.prevent="submit"
          class="unit-import__form"
          :title="$t('unitImport')"
          :subtitle="$t('importUnitsHere')"
          variant="prompt"
        >
          <template #default>
            <div>
              <b>{{ $t('downloadTemplate') }}</b>
            </div>

            <div class="mt-2 row g-2">
              <ButtonComponent
                :label="$t('simplifiedTemplate')"
                tag="a"
                target="_blank"
                :href="downloadTemplateUrlSimple"
              />
              <ButtonComponent :label="$t('advancedTemplate')" tag="a" target="_blank" :href="downloadTemplateUrl" />
            </div>

            <FileComponent class="mt-4" v-model="file" :upload="fileHandler" :label="$tc('uploadCSVFile')" />
          </template>
          <template #actions>
            <ButtonComponent :label="$t('goBack')" @click="goBack" />

            <ButtonComponent
              type="submit"
              :label="$t('import')"
              :promise="promise"
              :disabled="!file || (response && !response.failed)"
              :icon="['fal', 'arrow-to-right']"
              theme="primary"
            />
          </template>
        </Card>
        <Alert v-if="response" :theme="response.failed ? 'error' : 'success'" class="mt-2">
          <template v-if="!response.dry">
            {{
              $t('importedXItem', { count: response.imported, item: $tc('unit', response.imported).toLowerCase() })
            }}</template
          >

          <template v-if="response.failed">
            <div class="mb-1">{{ $t('importFailedResolveIssues') }}</div>
            <div style="word-break: break-all" v-html="errors"></div>
          </template>
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card-v2'
import { FileComponent } from '@kvass/file'
import { AlertComponent as Alert } from 'vue-elder-alert'

const templateUrlSimple = {
  nb: `https://docs.google.com/spreadsheets/d/1qP0jWpN2S0KJf_HKo3YfxuA_zlBK2cqxLkndHI9tPN8/edit?gid=0#gid=0`,
  en: `https://docs.google.com/spreadsheets/d/17FDxDicgQq9xDMWIhBPqWF3CpJ_N2goqHfBBAomaIUM/edit?usp=sharing`,
}

const templateUrl = {
  nb: `https://docs.google.com/spreadsheets/d/1DQUTGvfnvxTkLgwHHXYA51IjiGUkALiDiGlqFS2VAT8/edit?usp=sharing&single=true&output=csv`,
  en: 'https://docs.google.com/spreadsheets/d/1l1WBspNAGVguzGJsZ_7lglLGXZ4-gt3SOPQSSgBkIUQ/edit?usp=sharing',
}

export default {
  props: {
    language: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      file: null,
      response: null,
      promise: null,
    }
  },
  computed: {
    downloadTemplateUrl() {
      return templateUrl[this.language] || templateUrl['en']
    },
    downloadTemplateUrlSimple() {
      return templateUrlSimple[this.language] || templateUrl['en']
    },
    errors() {
      if (!this.response || !this.response.failed) return
      return JSON.stringify(this.response.details.error, null, { space: '  ' })
    },
  },
  methods: {
    async fileHandler(file) {
      this.response = null
      if (!file) return
      return {
        name: file.name,
        size: file.size,
        type: file.type,
        value: file,
        url: '#',
      }
    },
    upload(options = {}) {
      let { dry = true } = options

      if (!this.file) return Promise.reject(new Error('Missing file'))

      return new Promise((resolve, reject) => {
        let url = '/api/import/unit'
        if (!dry) url += '?run=true'
        let data = new FormData()
        data.append('file', this.file.value)

        let xhr = new XMLHttpRequest()
        xhr.responseType = 'json'
        xhr.onreadystatechange = function () {
          if (this.readyState !== 4) return
          if (this.status >= 200 && this.status <= 400) return resolve(xhr.response)
          return reject(xhr.response)
        }
        xhr.open('POST', url)

        xhr.send(data)
      })
    },
    submit() {
      this.promise = this.upload()
        .then(data => {
          if (!data.failed && data.dry) return this.upload({ dry: false })
          return data
        })
        .then(data => {
          this.response = data
        })
    },

    goBack() {
      const prev = this.$router.app.$previousRoute

      if (prev && prev.name) {
        this.$router.push(prev.fullPath)
      } else {
        this.$router.push('/')
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t('unitImport'),
    }
  },
  components: {
    Card,
    FileComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.unit-import {
  background-color: $background-grey;

  &__wrapper {
    max-width: 600px;
    margin: 0 auto;
  }
}
</style>
